<time [attr.datetime]="dateISO" [attr.title]="date | date:'dd/MM/yyyy, HH:mm:ss'">
  {{ date | date:format }}
</time>
